import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { withAuth } from '../Auth';

import { LayoutScopeProvider } from './LayoutScopeContext';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import SupportWidget from '../../Components/SupportWidget';
import classes from './styles.module.css';

function RoleLayoutBase({
    children,
    scope,
    menuConfig,
    adminPrivileges,
    isAuthorized,
    footerProps,
    fallbackPath,
}) {
    if (!isAuthorized) {
        return <Redirect to="/login" />;
    }

    const isAdminScope = scope === 'admin';
    const resolvedMenuConfig = typeof menuConfig === 'function' ? menuConfig({ adminPrivileges }) : menuConfig;

    if (isAdminScope && !adminPrivileges) {
        return <Redirect to={fallbackPath} />;
    }

    const contentClassName = `${classes.Content}${scope === 'user' ? ' ' + classes.UserContent : ''}`;

    return (
        <LayoutScopeProvider value={{ scope, hideLegacyMenus: true }}>
            <div className={classes.Wrapper}>
                <Header menuConfig={resolvedMenuConfig} />

                <div className={contentClassName}>
                    <Switch>{children}</Switch>
                </div>

                <Footer {...footerProps} />
                <SupportWidget />
            </div>
        </LayoutScopeProvider>
    );
}

export default withAuth(RoleLayoutBase);



// WEBPACK FOOTER //
// ./src/hoc/Layout/RoleLayout.js